<div class="actual-working-hours-container">
  <h2 mat-dialog-title>Saisir les horaires réels de travail</h2>

  <div *ngIf="isLoading" class="loading-container">
    <mat-spinner diameter="40"></mat-spinner>
    <p>Chargement des horaires...</p>
  </div>

  <form [formGroup]="workingHoursForm" *ngIf="!isLoading">
    <!-- Informations de la mission -->
    <mat-dialog-content>
      <div class="mission-info" *ngIf="establishmentName || serviceName || missionReference">
        <div class="info-row" *ngIf="establishmentName">
          <strong>Nom de l'établissement:</strong> {{ establishmentName }}
        </div>
        <div class="info-row" *ngIf="serviceName">
          <strong>Nom du service:</strong> {{ serviceName }}
        </div>
        <div class="info-row" *ngIf="missionReference">
          <strong>Référence de la mission:</strong> {{ missionReference }}
        </div>
      </div>

      <div *ngIf="data.status !== 'DRAFT'" class="sent-hours-info">
        <p>Les heures ont déjà été envoyées pour validation et ne peuvent plus être modifiées.</p>
      </div>

      <div formArrayName="dailyWorkingHours" [hidden]="data.status !== 'DRAFT'">
        <div *ngFor="let day of dailyWorkingHours.controls; let i = index" [formGroupName]="i" class="day-container">
          <h3>{{ getFormattedDate(missionDates[i]) }}</h3>

          <div class="form-row">
            <mat-form-field>
              <mat-label>Heure de début</mat-label>
              <input matInput type="time" formControlName="actualStartTime" required>
              <mat-error *ngIf="day.get('actualStartTime')?.hasError('required')">
                L'heure de début est requise
              </mat-error>
            </mat-form-field>

            <mat-form-field>
              <mat-label>Heure de fin</mat-label>
              <input matInput type="time" formControlName="actualEndTime" required>
              <mat-error *ngIf="day.get('actualEndTime')?.hasError('required')">
                L'heure de fin est requise
              </mat-error>
            </mat-form-field>
          </div>
        </div>
      </div>
    </mat-dialog-content>

    <mat-dialog-actions align="end">
      <button mat-button type="button" (click)="onCancel()">Annuler</button>
      <button mat-raised-button color="primary" (click)="onSubmit(false)"
        [disabled]="!workingHoursForm.valid || data.status !== 'DRAFT'">
        Enregistrer en brouillon
      </button>
      <button mat-raised-button color="accent" (click)="onSubmit(true)"
        [disabled]="!workingHoursForm.valid || data.status !== 'DRAFT'">
        Signer et envoyer
      </button>
    </mat-dialog-actions>
  </form>
</div>